import { useEffect, useState } from "react";

import TechAreaForm from "./TechAreaForm";
import TechRoleForm from "./TechRoleForm";
import { useTranslation } from "react-i18next";
import { JobRoleDetailService } from "../../services/JobRoleDetailService";
import { DropDownMultiCheck } from "../../pages/Interview/AdvanceSearch/DropDownMultiCheck";
import SimpleModal from "../SimpleModal/SimpleModal";

export default function JobRoleDetailTreeModal({
  isOpen,
  onClose,
  setJobRoleDetails,
  jobRoleDetails,
  techAreaFieldName,
  techRoleFieldName
}) {
  const [techAreas, settechAreas] = useState([]);
  const [originalTechAreas, setOriginalTechAreas] = useState([]);
  const [techRoles, setTechRoles] = useState([]);
  const [technologies, setTechnologies] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);

  const CURRENT_FORM = { techarea: 0, techrole: 1 };
  const [currentFom, setCurrentFom] = useState(CURRENT_FORM.techarea);

  let { t } = useTranslation();
  const [modalTitle, setModalTitle] = useState(
    t("Select Profissional Category")
  );

  useEffect(() => {
    JobRoleDetailService.getJobRoleTree().then((data) => {
      settechAreas(data);
      setOriginalTechAreas(data);
      let _technologies = [];
      data.forEach((x) => {
        x.techRoles.forEach((y) => {
          y.technologies.forEach((z) => {
            if (!_technologies.find((t) => t.description === z.description))
              _technologies.push(z);
          });
        });
      });
      setTechnologies(_technologies);
    });
  }, []);
  useEffect(() => {
    if (selectedSkills.length > 0) {
      let _techAreas = [];
      _techAreas = originalTechAreas.filter((x) => {
        let techRoles = x.techRoles.filter((y) => {
          let technologies = y.technologies.filter((z) =>
            selectedSkills.find((s) => s.description === z.description)
          );
          return technologies.length > 0;
        });
        return techRoles.length > 0;
      });
      _techAreas.forEach((x) => {
        x.techRoles = x.techRoles.filter((y) => {
          let technologies = y.technologies.filter((z) =>
            selectedSkills.find((s) => s.description === z.description)
          );
          return technologies.length > 0;
        });
      });
      settechAreas(_techAreas);
    } else {
      settechAreas(originalTechAreas);
    }
    setCurrentFom(CURRENT_FORM.techarea);
  }, [selectedSkills]);

  useEffect(() => {
    if (jobRoleDetails?.techAreaId) {
      setTechRoles(
        techAreas.find((x) => x.id === Number(jobRoleDetails.techAreaId))
          ?.techRoles
      );
    }
  }, [jobRoleDetails.techAreaId]);

  function onCloseModal() {
    setModalTitle(t("Select Profissional Category"));
    setCurrentFom(CURRENT_FORM.techarea);
    onClose();
  }
  function onSelectTechArea(techArea) {
    if (techArea) {
      setTechRoles(techArea.techRoles);
      setJobRoleDetails({
        target: { name: techAreaFieldName, value: techArea.id }
      });
      setCurrentFom(CURRENT_FORM.techrole);
      setModalTitle(t("Select Role"));
    }
  }
  function onSelectTechRole(techRole) {
    setJobRoleDetails({
      target: { name: techRoleFieldName, value: techRole.id }
    });
    onCloseModal();
  }
  function OnSave() {
    onCloseModal();
  }
  function goBack() {
    setCurrentFom(CURRENT_FORM.techarea);
    setModalTitle(t("Select Profissional Category"));
  }
  function goFoward() {
    if (!jobRoleDetails.techAreaId) return;
    setModalTitle(t("Select Role"));
    setCurrentFom(CURRENT_FORM.techrole);
  }

  function getTechRoleBreedCrumps() {
    let label = "Choose a Role";
    let techArea = techAreas.find(
      (x) => x.id === Number(jobRoleDetails.techAreaId)
    );
    let techRole = techArea?.techRoles.find(
      (x) => x.id === Number(jobRoleDetails.techRoleId)
    );
    if (techRole)
      return `${techArea?.description}/${techRole?.description}/${label}`;

    return `${techArea?.description}/${label}`;
  }
  function getTechAreaBreedCrumps() {
    let label = "Choose a Profissional Category";
    let techArea = techAreas.find(
      (x) => x.id === Number(jobRoleDetails.techAreaId)
    );
    if (techArea) return `${techArea?.description}/ ${label}`;

    return label;
  }

  return (
    <>
      <SimpleModal
        isOpen={isOpen}
        title={modalTitle}
        size="lg"
        overlay={true}
        onClose={onCloseModal}
        actionPosition={"spaceBetween"}
        submitButtonAction={
          currentFom === CURRENT_FORM.techarea ? goFoward : OnSave
        }
        submitButtonTitle={
          currentFom === CURRENT_FORM.techarea ? t("Next") : t("Close")
        }
        cancelButtonAction={
          currentFom === CURRENT_FORM.techarea ? onCloseModal : goBack
        }
        cancelButtonTitle={
          currentFom === CURRENT_FORM.techarea ? t("Cancel") : t("Go Back")
        }
      >
        {currentFom === CURRENT_FORM.techarea && (
          <>
            <div className="row  mb-2">
              <div className="col align-middle">{getTechAreaBreedCrumps()}</div>

              <div className="col-6">
                <div>
                  <DropDownMultiCheck
                    dataList={technologies}
                    selecteds={selectedSkills}
                    setSelecteds={setSelectedSkills}
                    autoCompleteMode={true}
                  />
                </div>
              </div>
            </div>
            <div className="row ">
              <TechAreaForm
                techAreas={techAreas}
                jobRoleDetails={jobRoleDetails}
                onSelectTechArea={onSelectTechArea}
              />
            </div>
          </>
        )}
        {currentFom === CURRENT_FORM.techrole && (
          <>
            <div className="row  mb-2">
              <div className="col">
                <p>{getTechRoleBreedCrumps()}</p>
              </div>

              <div className="col-2">
                <div>
                  <DropDownMultiCheck
                    dataList={technologies}
                    selecteds={selectedSkills}
                    setSelecteds={setSelectedSkills}
                    autoCompleteMode={true}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <TechRoleForm
                techRoles={techRoles}
                jobRoleDetails={jobRoleDetails}
                onSelectTechRole={onSelectTechRole}
              />
            </div>
          </>
        )}
      </SimpleModal>
    </>
  );
}
